import { useMemo } from "react";
import HttpService from "./httpService";
import nvCookieHelpers from "./cookieService";
import { useTranslation } from "react-i18next";
import gobalization from "../constants/globalization";
import { config } from "../config";
import { getShippingMethodKey } from "./shippingMethodService";
const useHttpService = () => {
    const enviromentURL = () => {
        let envURL = "https://api.store.nvidia.com";
        let host = window.location.hostname;
        if (host.split(".")[0] !== "store" && host !== "marketplace.nvidia.com") {
            envURL = `https://${host.split(".")[0].split("-")[0]}-api.store.nvidia.com`;
        }
        if (host.indexOf("localhost") > -1) {
            envURL = "http://localhost:5000";
        }
        return envURL;
    };

    const API_URL = useMemo(() => enviromentURL(), []);
    const httpService = useMemo(() => new HttpService(API_URL), [API_URL]);

    return httpService;
};


export const useCart = () => {
    const { t } = useTranslation();
    const httpService = useHttpService();
    const sessionexpiredID = nvCookieHelpers.getCookie('session_expired');
    const getCart = async (handleSuccess: (result: any) => void, handleError: (err: string) => void, isInit?: boolean) => {
        console.log('sessionID==>', sessionexpiredID);
        try {
            if (isInit || (sessionexpiredID && !JSON.parse(sessionexpiredID))) {
                const result = await httpService.get("/cart-management/v2/cart/active");
                let resultLength = Object.keys(result.cartItems).length;
                if (result && resultLength > 0) {
                    // Translate shipping method description if available
                    if (result.shippingOptions && result.shippingOptions.shippingOption &&
                        result.shippingOptions.shippingOption.length > 0) {
                        try {
                            // Extract brand and first product ID
                            const brand = result.brand;
                            const productId = result.cartItems?.cartItem?.[0]?.product?.id;
                            const locale = result.locale;

                            if (brand && productId) {
                                // Get the shipping method translation key
                                const shippingKey = await getShippingMethodKey(productId, brand, locale);

                                if (shippingKey) {
                                    // Translate and replace the description in the first (and only) shipping option
                                    const translatedDescription =
                                        shippingKey === "SHIPPING_TWO_DAY" ? t("FREE_SHIPPING") : t(shippingKey);
                                    result.shippingOptions.shippingOption[0].description = translatedDescription;
                                    // Store the key for potential future use - TODO: MIGHT NOT NEED THIS ... ?
                                    result.shippingMethodKey = shippingKey;
                                }
                            }
                        } catch (shippingError) {
                            console.error('Error translating shipping method:', shippingError);
                            // Continue with original description if translation fails
                        }
                    }

                    handleSuccess(result);
                } else {
                    handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
            } else {
                if (!sessionexpiredID) {
                    handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.error(er);
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
    };

    const createCart = async (requestBody: any, headerObj: any, handleSuccess: () => void, handleError: (err: string) => void) => {
        try {
            const result = await httpService.postCart("/cart-management/v2/cart/active", requestBody, headerObj);
            if (result === 200) {
                handleSuccess();
            } else {
                handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            }
        } catch (er) {
            console.error(er);
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
        }
    }

    const updateCart = async (handleSuccess: (result: any, productId?: number) => void, handleError: (err: string, productId?: number) => void, productId?: string, selectedOption?: number, shippingOption?: string, coupon?: string, currency?: any, couponApplied?: boolean | undefined) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody = {}
                if (productId && (selectedOption !== undefined && selectedOption !== null)) {
                    cartBody = { cart: { products: [{ productId: productId, quantity: selectedOption }] } };
                } else if (shippingOption !== undefined && shippingOption !== null) {
                    cartBody = { shippingOptionId: shippingOption.toString() };
                } else if (currency) {
                    cartBody = currency;
                } else if (couponApplied) {
                    cartBody = { 'remove_coupon': couponApplied };
                } else {
                    cartBody = { promoCode: coupon || '' };
                }
                const result = await httpService.put("/cart-management/v2/cart/active", cartBody, headerObj);
                if (result) {
                    if (productId) {
                        handleSuccess(result, Number(productId));
                    } else {
                        handleSuccess(result);
                    }
                }
            } else {
                if (!sessionexpiredID) {
                    if (productId) {
                        handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'), Number(productId));
                    } else {
                        handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                    }
                }
                throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.error(er);
            if (productId) {
                handleError('', Number(productId));
            } else {
                handleError('');
            }
        }
    };
    const submitCart = async (order: any, handleCartSuccess: (result: any) => void, handleCartError: (err: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody;
                cartBody = { cart: { ...order.cart, ...gobalization(order.locale, order.brand) } }
                console.log('[SUBMIT CART - Billing Address]', JSON.stringify(cartBody.cart.billingAddress, null, 2));
                console.log('[SUBMIT CART - Shipping Address]', JSON.stringify(cartBody.cart.shippingAddress, null, 2));
                const locale = cartBody['cart']?.locale?.toLowerCase();
                const europeanLocales = ['eu', 'fr', 'nl', 'de'];

                if (europeanLocales.some(euLocale => locale?.includes(euLocale))) {
                    const countryCode = cartBody['cart'].shippingAddress.country.match(/\(([^)]+)\)/)?.[1] || cartBody['cart'].shippingAddress.country;
                    const europeanLocale = cartBody['cart']?.locale.replace(/eu|fr|nl|de/i, countryCode).replace('-', '_');
                    cartBody = { cart: { ...cartBody['cart'], locale: europeanLocale } }
                }
                console.log('[CHECKOUT API PAYLOAD]', JSON.stringify(cartBody, null, 2));
                const result = await httpService.post("/cart-management/v2/checkout", cartBody, headerObj);
                if (result) {
                    handleCartSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleCartError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er, er?.error);
            // Check if error has specific code (e.g., postal_code_invalid)
            if (er && er.message.length) {
                let errMsg = JSON.parse(er?.message);
                if (errMsg && (errMsg?.error?.code === 'postal_code_invalid' || errMsg?.error?.code === 'restricted-ship-to-country')) {
                    handleCartError(errMsg?.error);
                } else {
                    handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
                }
            } else {
                handleCartError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
            }
        }
    }
    const submitCapatcha = async (orderToken: any, handleCapatchaSuccess: (result: any) => void, handleCapatchaError: () => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                let cartBody = { "event": orderToken };
                const result = await httpService.post("/cart-management/v2/checkout/assessments", cartBody, headerObj);
                console.log("submitCapatcha==>", result);
                if (result) {
                    handleCapatchaSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleCapatchaError();
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.log(er);
            handleCapatchaError();
        }
    }

    const getPaymentIntent = async (
        deviceFingerprintUuid: { request_uuid: string },
        handlePaymentIntentSuccess: (result: any) => void,
        handlePaymentIntentError: (err: any) => void
    ) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let headerObj = { "content-type": "application/json" };
                const result = await httpService.post("/cart-management/v2/checkout/authorize", deviceFingerprintUuid, headerObj);
                if (result) {
                    handlePaymentIntentSuccess(result);
                } else {
                    handlePaymentIntentError(t('CART_PAYMENT_FAILURE'));
                }
            } else {
                if (!sessionexpiredID) {
                    handlePaymentIntentError(t('CART_PAYMENT_FAILURE'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er);
            handlePaymentIntentError(er);
        }
    }
    const submitOrder = async (handleOrderSuccess: (result: any) => void, handleOrderError: (e: any) => void, paymentSuccess: boolean, eventDetail?: any) => {
        try {
            if ((sessionexpiredID && !JSON.parse(sessionexpiredID))) {
                let headerObj = { "content-type": "application/json" };
                const result = await httpService.submitOrderPost("/cart-management/v2/checkout/submit-cart", { paymentSuccess: paymentSuccess, eventDetail: eventDetail ? { ...eventDetail } : null }, headerObj);
                console.log('SUBMIT CART',)
                if (result) {
                    handleOrderSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleOrderError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er: any) {
            console.log(er.error);
            if (er && er?.error) {
                handleOrderError(er?.error);
            } else {
                handleOrderError({ code: 'unknown_error', message: t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY') });
            }
        }
    }
    const submitAddress = async (address: any, handleAddressSuccess: (result: any) => void, handleAddressError: (err: any) => void) => {
        try {
            if (sessionexpiredID && !JSON.parse(sessionexpiredID)) {
                let cartBody = {
                    "address": address,
                    // "languageOptions": {
                    //     "languageCode": "en"
                    // },
                }

                const result = await httpService.postAddress("https://addressvalidation.googleapis.com/v1:validateAddress?key=" + config.mapKey, cartBody);
                console.log("submitAddress==>", result);

                if (result) {
                    handleAddressSuccess(result);
                }
            } else {
                if (!sessionexpiredID) {
                    handleAddressError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                // throw new Error('User Session has been expired');
            }
        } catch (er) {
            console.log('submitAddress error==>', er);
            handleAddressError(er);
        }
    }
    return { getCart, createCart, updateCart, submitCart, submitCapatcha, submitOrder, submitAddress, getPaymentIntent };
};